import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';

declare var bootbox:any;

@Component({
  selector: 'app-categories',
  template: require('./categories.component.html')
})
export class CategoriesComponent extends BaseComponent implements OnInit {

  public categories = [];

  ngOnInit() {
    this.loadCategories();
  }

  public loadCategories() {
    this.busy = this.lsApi.getCategories().subscribe(resp => {
        if(resp.status) {
            this.categories = resp.data;
            if(this.categories.length>0) {
              this.initDataTable(
                "#tblData",
                [
                  { "bSearchable": true, },  //col 2
                  { "bSearchable": false, bSortable: false }, //col 5
                  { "bSearchable": false, bSortable: false } //col 6 
                ],0
              );
            }
            //this.router.navigate([this.router.url]);
        }
    },
    error => {
        console.log(error);
    });
  }

  public deleteCategories(cat) {
    
    
    bootbox.confirm({message:"Do you want to delete '" + cat.name + "' category and all it's data?<br><small>All their data will be lost. This cannot be undone.</small>",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

          this.busy = this.lsApi.deleteCategoryById(cat.categoryId).subscribe(resp => {
              if(resp.status) {
                  this.appToast.success("Category Successfully Deleted","Category Deleted");
                  this.loadCategories();
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/categories/categories.component.ts